import React from "react";
import { Controller } from "react-hook-form";
import Rating from "@mui/material/Rating";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import styles from "./order-feedback.module.scss";

const RatingsV2 = ({ id, control, value, label }) => {
    return (
        <div className={styles.ratingV2Container} data-testid="ratings-v2">
            {label && <p className="fontWeight600">{label}</p>}

            <Controller
                name={id}
                control={control}
                defaultValue={value ? parseInt(value) : 0}
                render={({ field: { onChange, value } }) => (
                    <Rating
                        name={id}
                        value={value ? parseInt(value) : 0}
                        onChange={(event, newValue) => {
                            onChange(newValue?.toString() ?? "0");
                        }}
                        icon={<StarRoundedIcon fontSize="large" />}
                        emptyIcon={
                            <StarRoundedIcon fontSize="large" style={{ opacity: 0.3 }} />
                        }
                    />
                )}
            />
        </div>
    );
};

export default RatingsV2;
